
export default function initFormulaire() {
    const $blocksFormulaire = document.querySelectorAll<HTMLElement>('.block-formulaire');
    $blocksFormulaire.forEach($container => {
        new BlockFormulaire($container);
    });
}

/**
 * @param {HTMLElement} $el           HTML Element Block formulaire
 */
class BlockFormulaire {
    $el: HTMLElement | null | undefined;
    $successMessage: HTMLElement | null | undefined;
    $formContainer: HTMLElement | null | undefined;
    
    constructor($el: HTMLElement | null) {
        this.$el = $el;
        this.$formContainer = this.$el?.querySelector('.form-container');
        this.$successMessage = this.$el?.querySelector('.success-message');
 
        this.init();
    }

    init() {
        document.addEventListener('wpcf7mailsent', () => {
            if (this.$formContainer && this.$successMessage) {
                this.$formContainer.style.display = 'none';
                this.$successMessage.style.display = 'block';
            }
        }, false);
    }
}
